import { useAtom } from "jotai";
import { ReactNode } from "react";

import { darkModeAtom } from "../../modules/ui/ui.atom";
import { TuvNordLogo } from "../shared/TuvNordLogo";
import { Toast } from "../utils/Toast";
import { Sidebar1 } from "./Sidebar1";
import { Sidebar2 } from "./Sidebar2";

type HomeLayoutProps = {
    children: ReactNode;
};

export const HomeLayout = ({ children }: HomeLayoutProps) => {
    const [darkMode] = useAtom(darkModeAtom);
    return (
        <>
            <div
                className=""
                data-theme={darkMode ? "custom-business" : "custom-corporate"}
            >
                <Sidebar1 />
                <Sidebar2 />
                <div className="ml-[306px] min-h-screen bg-base-200 max-w-[calc(100vw_-_306px)]">
                    <div className="bg-base-100 h-8 relative shadow-2xl">
                        <p className="bg-primary absolute right-8 px-8 py-2 shadow-2xl rounded-b-xl">
                            <TuvNordLogo white className="w-20 h-16" />
                        </p>
                    </div>
                    <div className="p-8">{children}</div>
                </div>
            </div>
            <Toast />
        </>
    );
};
